export default function SectionHeading({ eyebrow, title, subtitle, align = "left", invert = false }) {
  return (
    <div className={`${align === "center" ? "text-center mx-auto max-w-2xl" : "max-w-2xl"} mb-12`}>
      {eyebrow && (
        <div
          className={`text-xs font-semibold uppercase tracking-[0.22em] mb-3 ${
            invert ? "text-[var(--ec-lake-light)]" : "text-[var(--ec-lake)]"
          }`}
        >
          {eyebrow}
        </div>
      )}
      <h2
        className={`font-display text-4xl sm:text-5xl lg:text-[3.25rem] leading-[1.05] tracking-tight ${
          invert ? "text-white" : "text-[var(--ec-navy)]"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-5 text-base sm:text-lg leading-relaxed ${invert ? "text-white/75" : "text-[var(--ec-charcoal)]/75"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
